import { useContext } from 'react';
import { BraceletGiftContext } from '@/contexts/braceletGiftContextValue';

export const useBraceletGift = () => useContext(BraceletGiftContext);
